import { render, staticRenderFns } from "./ModifyLoanRequest.vue?vue&type=template&id=2f188c02"
import script from "./ModifyLoanRequest.vue?vue&type=script&lang=js"
export * from "./ModifyLoanRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports